import { IconBrandWhatsapp as TablerIconBrandWhatsapp } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconBrandWhatsapp = /*#__PURE__*/ createOutlineIcon(
  TablerIconBrandWhatsapp,
  'IconBrandWhatsapp',
);
